import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendTrackDataServer } from "./serverTrackData";

export const UseTrackPageView = () => {
  const location = useLocation();
  useEffect(() => {
    sendTrackDataServer({
      url: location.pathname,
      eventName: "PAGE_VIEW",
      productType: "PO",
      data: {
        search: location.search,
        title: document.title,
      },
    });
  }, [location]);
};
